var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _ = require("lodash");

var toQueryString = function toQueryString(obj) {
  return _.map(obj, function (v, k) {
    return encodeURIComponent(k) + "=" + encodeURIComponent(v);
  }).join("&");
};

var BaseResource = /*#__PURE__*/function () {
  "use strict";

  function BaseResource(client) {
    _classCallCheck(this, BaseResource);

    this.client = client;
  }

  _createClass(BaseResource, [{
    key: "_get",
    value: function () {
      var _get2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
        var options,
            response,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _context.next = 3;
                return this.client.get(path, options);

              case 3:
                response = _context.sent;
                return _context.abrupt("return", response.data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _get(_x) {
        return _get2.apply(this, arguments);
      }

      return _get;
    }()
  }, {
    key: "_head",
    value: function () {
      var _head2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path) {
        var options,
            response,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                _context2.next = 3;
                return this.client.head(path, options);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _head(_x2) {
        return _head2.apply(this, arguments);
      }

      return _head;
    }()
  }, {
    key: "_options",
    value: function () {
      var _options2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path) {
        var options,
            response,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                _context3.next = 3;
                return this.client.options(path, options);

              case 3:
                response = _context3.sent;
                return _context3.abrupt("return", response.data);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _options(_x3) {
        return _options2.apply(this, arguments);
      }

      return _options;
    }()
  }, {
    key: "_post",
    value: function () {
      var _post2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path, data) {
        var options,
            response,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
                _context4.next = 3;
                return this.client.post(path, data, options);

              case 3:
                response = _context4.sent;
                return _context4.abrupt("return", response.data);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _post(_x4, _x5) {
        return _post2.apply(this, arguments);
      }

      return _post;
    }()
  }, {
    key: "_put",
    value: function () {
      var _put2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(path, data) {
        var options,
            response,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
                _context5.next = 3;
                return this.client.put(path, data, options);

              case 3:
                response = _context5.sent;
                return _context5.abrupt("return", response.data);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _put(_x6, _x7) {
        return _put2.apply(this, arguments);
      }

      return _put;
    }()
  }, {
    key: "_patch",
    value: function () {
      var _patch2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(path, data) {
        var options,
            response,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                options = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                _context6.next = 3;
                return this.client.patch(path, data, options);

              case 3:
                response = _context6.sent;
                return _context6.abrupt("return", response.data);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _patch(_x8, _x9) {
        return _patch2.apply(this, arguments);
      }

      return _patch;
    }()
  }, {
    key: "_delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(path, data) {
        var options,
            response,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                options = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : {};
                _context7.next = 3;
                return this.client.delete(path, data, options);

              case 3:
                response = _context7.sent;
                return _context7.abrupt("return", response.data);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _delete(_x10, _x11) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return BaseResource;
}();

module.exports = BaseResource;